import { createApiRef } from '@backstage/core-plugin-api';
import { AxiosInstance } from 'axios';
import { AxiosInstanceProviderApi } from './axiosInstanceApi';

export interface ApmOption {
  ApmNumber: string;
  Name: string;
}

export interface ISubmitRatingRequest {
  resourceId: string;
  resourceType: string;
  rating: number;
  comment?: string;
  apmNumber?: string;
}

export interface IToolRating {
  resourceId: string;
  resourceType: string;
  avgRating?: number;
  totalRatings?: number;
  ratings: {
    id: string;
    userEmail: string;
    rating: number;
    comment?: string;
    ratedAt: string;
  }[];
}

export interface RatingsApi {
  getRatings: (
    resourceId: string,
    resourceType?: string,
  ) => Promise<IToolRating>;
  submitRating: (payload: ISubmitRatingRequest) => Promise<any>;
  getApms: () => Promise<ApmOption[]>;
}

export const ratingsApiRef = createApiRef<RatingsApi>({
  id: 'cbre.devx.api.ratings',
});

export class RatingsApiImpl implements RatingsApi {
  private readonly axiosInstancePromise: Promise<AxiosInstance>;

  constructor(axiosInstanceProviderApi: AxiosInstanceProviderApi) {
    this.axiosInstancePromise = axiosInstanceProviderApi.getInstance();
  }

  async getRatings(
    resourceId: string,
    resourceType = 'tool',
  ): Promise<IToolRating> {
    const instance = await this.axiosInstancePromise;
    return instance
      .get('service/ratings', { params: { resourceType, resourceId } })
      .then(res => res.data);
  }

  async submitRating(payload: ISubmitRatingRequest): Promise<any> {
    const instance = await this.axiosInstancePromise;
    return instance.post('service/ratings', payload).then(res => res.data);
  }

  async getApms(): Promise<ApmOption[]> {
    const instance = await this.axiosInstancePromise;
    return instance
      .get('service/registration/apminfo')
      .then(res => res?.data)
      .catch((err: any) => {
        throw new Error(
          `Error occurred while getting APM info: ${err.message}`,
        );
      });
  }
}
